import { useDataChange, useDataValue } from 'Simple/Data.js'
import {
  changeDiscountsAppliedToPayorsShare,
  changePayorsConfiguration,
} from 'Data/payment-plan.js'

export function useOnDelete(props) {
  let change = useDataChange({
    context: 'payment_plan',
    viewPath: props.viewPath,
  })
  let index = useDataValue({
    context: 'payor_item',
    path: 'index',
    viewPath: props.viewPath,
  })

  return function onDelete() {
    change(next => {
      let payor_person_id = next.payors[index].person_id

      if (payor_person_id) {
        let other_payor_person_id = next.payors.find(
          (_, i) => i !== index
        ).person_id
        next.discounts.forEach(discount => {
          if (
            discount.is_applied_to_payor &&
            discount.payor_person_id === payor_person_id
          ) {
            discount.payor_person_id = other_payor_person_id
          }
        })
      }

      // remove it only after making sure the discounts are adjusted
      next.payors.splice(index, 1)

      changeDiscountsAppliedToPayorsShare(next)
      changePayorsConfiguration(next)
    })
  }
}
